<p-toast></p-toast>

<app-documents-search [docStrString]="docStrString"
                      [cliStrString]="cliStrString"
                      [lcoStrString]="lcoStrString"
                      [proStrString]="proStrString"
                      [(display)]="searchDocumentDialog"></app-documents-search>

<app-create-new-document [parentDocumentId]="selectedDocumentId" [agentRequestId]="agentRequestId" [display]="displayND" (displayChange)="onDisplayNDChange($event)" (done)="onReloadAllData($event)" *ngIf="displayND">

</app-create-new-document>

<app-documents-tree [(display)]="displayDC"
                    [document]="selectedDocument2"
                    (selectedDocument)="onSelectDocumentTreeNode($event)"
                     *ngIf="displayDC">
</app-documents-tree>

<app-confirm-delete-product-part [(display)]="confirmDeleteDocumentOn"
                                 [typeConfirmation]="typeConfirmationOnDelete"
                                 [confirmText]="confirmDeleteDocumentText"
                                 (done)="onDeleteDocumentConfirmation($event)"
                                 *ngIf="confirmDeleteDocumentOn">
</app-confirm-delete-product-part>

<app-agent-bank-payment-review *ngIf="canSeeFinanceResult" [display]="displayBankPaymentReview"
                                (displayChange)="displayBankPaymentReview = $event"></app-agent-bank-payment-review>

<p-toolbar styleClass="">
  <ng-template pTemplate="left">

    <p-button label="New" icon="pi pi-plus" class="p-button-success mr-2 hide-label" (onClick)="displayND=true" pTooltip="Создать документ" tooltipPosition="top">
    </p-button>

    <p-button label="Delete" icon="pi pi-trash" class="p-button-danger mr-2 hide-label" (onClick)="deleteDocumentClick($event)"
              [disabled]="ifThereNotSelection" pTooltip="Удалить документ" tooltipPosition="top">
    </p-button>

    <p-button *ngIf="canSeeFinanceResult" label="Огляд банківських транзакцій" icon="pi pi-inbox" class="p-button-info mr-2 hide-label"
              (onClick)="displayBankPaymentReview = true"
              pTooltip="Відкрити чергу банківських транзакцій, що очікують обробки" tooltipPosition="top">
    </p-button>
    <!--      <button pButton pRipple label="Delete" icon="pi pi-trash" class="p-button-danger mr-2 hide-label" (click)="deleteDocumentClick($event)" [disabled]="ifThereNotSelection" pTooltip="Удалить документ" tooltipPosition="top"></button>-->
    <!--

    Too much additional steps to make the document valid for print/export
      Simply open the docuent and export.
      Sorry, guys

      <app-export-document [(display)]="exportDS" [documentId]="selectedDocumentId"></app-export-document>
    <button pButton pRipple label="Сохранить" icon="pi pi-print" class="p-button-help" (click)="onDocumentSave($event)" [disabled]="ifThereNotSelection" pTooltip="Сохранить документ для печати" tooltipPosition="top"></button>
    -->
  </ng-template>

  <ng-template pTemplate="right">
    <p-button label="Поиск..." icon="pi pi-search" class="p-button-success mr-3 hide-label" (onClick)="doDeepSearch($event)" iconPos="right"
              [disabled]="false" pTooltip="Поиск по всем документам" tooltipPosition="top">
    </p-button>

    <span class="p-input-icon-left mr-2 w-8rem md:w-6rem">
      <i class="pi pi-search"></i><input pInputText type="text" [(ngModel)]="docStrString" (keyup.enter)="doFastSearch($event)" placeholder="По документу..." />
    </span>
    <span class="p-input-icon-left mr-2 w-8rem md:w-6rem">
      <i class="pi pi-search"></i><input pInputText type="text" [(ngModel)]="cliStrString" (keyup.enter)="doFastSearch($event)" placeholder="По контрагенту..." />
    </span>
    <span class="p-input-icon-left mr-2 w-8rem md:w-6rem">
      <i class="pi pi-search"></i><input pInputText type="text" [(ngModel)]="lcoStrString" (keyup.enter)="doFastSearch($event)" placeholder="По юрлицу..." />
    </span>
    <span class="p-input-icon-left mr-2 w-8rem md:w-6rem">
      <i class="pi pi-search"></i><input pInputText type="text" [(ngModel)]="proStrString" (keyup.enter)="doFastSearch($event)" placeholder="По товару..." />
    </span>

    <p-button icon="pi pi-filter" styleClass="p-button-success" class="mr-2 mr-2 hide-label" (onClick)="doFastSearch($event)" [disabled]="!ifSomethingToFilter"
              pTooltip="Найти документы по заданным полям (документ, контрагент, юрлицо, товар)" tooltipPosition="top"></p-button>
    <p-button icon="pi pi-filter-slash" styleClass="p-button-success" class="mr-2 mr-4 hide-label" (onClick)="doResetFastSearch($event)" [disabled]="!ifSomethingToFilter"
              pTooltip="Очистить фильтр поиска" tooltipPosition="top"></p-button>

    <p-button label="Сбросить фильтр" icon="pi pi-undo" styleClass="p-button-success" class="mr-2 hide-label"
              (onClick)="clearOrResetTableFilter($event)" pTooltip="Сбросить фильтр, внешний вид и вернуться в начало" tooltipPosition="top">

    </p-button>

    <p-button label="Обновить" icon="pi pi-refresh" styleClass="p-button-success" class="mr-2 hide-label" (onClick)="onReloadAllData($event)"
              pTooltip="Обновить список документов" tooltipPosition="top">
    </p-button>

    <p-button label="XLSX" icon="pi pi-file-excel" class="p-button-info hide-label"
              (onClick)="onExportData()" [disabled]="!canExport" pTooltip="Экспортировать список документов" tooltipPosition="top">
    </p-button>
  </ng-template>
</p-toolbar>

<p-contextMenu #cm [model]="items" styleClass="contextMenu" (onShow)="onShowComtextMenu($event)"></p-contextMenu>

<p-table #dt
         [value]="dlCurr"
         [lazy]="true"
         (onLazyLoad)="loaddl($event)"
         [loading]="loading"
         [rows]="rows"
         [rowsPerPageOptions]="[10,25,50,100]"
         [showCurrentPageReport]="true"
         [totalRecords]="totalRecords"
         [paginator]="true"
         paginatorPosition="both"
         currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} документов"
         styleClass="p-datatable p-datatable-gridlines p-datatable-striped"
         [filterDelay]="300"
         [globalFilterFields]="['ALL','CLIENTSNAME','DOCNOTE1','DOCNOTE2','PERSONNAME']"
         (onFilter)="handleFilter($event)"
         [(contextMenuSelection)]="selectedDocument"
         [contextMenu]="cm"
         dataKey="DOCID"
         selectionMode="single"
         [(selection)]="selectedDocument"
         (onRowSelect)="onRowSelect($event)"
         (onRowUnselect)="onRowUnselect($event)"
         [rowHover]="true"
         stateStorage="local"
         stateKey="documentList-state"
         (onStateSave)="onStateSave($event)"
         (onStateRestore)="onStateRestore($event)"
         rowExpandMode="single"
         [resizableColumns]="true"
         columnResizeMode="fit"
         (onRowExpand)="onRowExpanding($event)"
         [tableStyle]="{ 'min-width': '100rem' }">

  <ng-template pTemplate="caption">
    <div class="grid">
      <div class="col-2">
        <div class="text-left ml-2">
          <h3>Документы</h3>
        </div>
      </div>
      <div class="col">
        <div class="text-center"></div>
      </div>
      <div class="col">
        <div class="text-center"></div>
      </div>
      <div class="col">
        <div class="text-center"></div>
      </div>
      <div class="col">
        <div class="text-center">
          <span>
            <h6>Валюта</h6>
            <p-inputSwitch (onChange)="onShowCurrencyColumnChange($event)" [(ngModel)]="showCurrencyColumn" pTooltip="Показать колонку валюты документа" tooltipPosition="top"></p-inputSwitch>
          </span>
        </div>
      </div>
      <div class="col">
        <div class="text-center">
          <h6>Полное имя</h6>
          <p-inputSwitch (onChange)="onShowFullNameColumnChange($event)" [(ngModel)]="showFullNameColumn" pTooltip="Показывать полное имя контрагента" tooltipPosition="top"></p-inputSwitch>
        </div>
      </div>
      <div class="col-2">
        <div class="text-center">
          <h6>Загружать документы за {{monthToLoad}} месяцев</h6>
          <p-slider [(ngModel)]="monthToLoad" [min]="minMonths" [max]="maxMonths" [step]="6" (onChange)="onSlideChange($event)" (onSlideEnd)="onSlideEnd($event)"></p-slider>
        </div>
      </div>
      <div class="col-2">
        <div class="text-center">
          <p-button icon="pi pi-sitemap" (onClick)="showDoctreeButtonClick($event)" [disabled]="ifThereNotSelection" styleClass="p-button-help mr-2" pTooltip="Дерево документов" tooltipPosition="top"></p-button>
          <p-button icon="pi pi-arrow-up" (onClick)="moveToParentDocumentBtn($event)" [disabled]="ifSelectedHasNotParent" styleClass="p-button-secondary mr-3" pTooltip="Перейти к первичному" tooltipPosition="top"></p-button>

          <p-button icon="pi pi-tag" (onClick)="markBookmark1($event)" [disabled]="ifThereNotSelection"
                    [badge]="isThereBookmark1 ? 1 : 0" badgeClass="isThereBookmark1 ? 'p-badge-info' : ''" styleClass="p-button-secondary mr-2" pTooltip="Закладка 1" tooltipPosition="top"></p-button>
          <p-button icon="pi pi-tag" (onClick)="markBookmark2($event)" [disabled]="ifThereNotSelection"
                    [badge]="isThereBookmark2 ? 2 : 0" badgeClass="isThereBookmark2 ? 'p-badge-info' : ''" styleClass="p-button-secondary mr-2" pTooltip="Закладка 2" tooltipPosition="top"></p-button>
          <p-button icon="pi pi-tag" (onClick)="markBookmark3($event)" [disabled]="ifThereNotSelection"
                    [badge]="isThereBookmark3 ? 3 : 0" badgeClass="isThereBookmark3 ? 'p-badge-info' : ''" styleClass="p-button-secondary mr-3" pTooltip="Закладка 3" tooltipPosition="top"></p-button>
        </div>
      </div>
      <div class="col">
        <div class="text-right">
          <input id="gsb" pInputText
                 type="text" [(ngModel)]="documentGlobalFilter"
                 (input)="dt.filterGlobal($event.target.value, 'contains')"
                  [class.hasvalue]="documentGlobalFilter"
                 placeholder="Быстрый фильтр по таблице" />
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th pResizableColumn style="width: 4rem"></th>
      <th pResizableColumn style="width: 3rem"></th>
      <th pResizableColumn style="width: 3rem">Статус</th>
      <th pResizableColumn style="width: 10% !important">Документ <p-sortIcon field="DOCNAME"></p-sortIcon></th>
      <th pResizableColumn style="width: 12rem !important">Номер <p-sortIcon field="DOCNUMBER"></p-sortIcon></th>
      <th pResizableColumn style="width: 10rem !important">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>
      <th pResizableColumn style="width: 8rem !important" *ngIf="showCurrencyColumn">Валюта <p-sortIcon field="CURCODE"></p-sortIcon></th>
      <th pResizableColumn style="width: 5% !important">Продавец <p-sortIcon field="LOCALCOMP"></p-sortIcon></th>
      <th pResizableColumn style="width: 5% !important">Автор <p-sortIcon field="AUTHOR"></p-sortIcon></th>
      <th pResizableColumn style="width: auto !important">Контрагент <p-sortIcon field="PARTNERNAMESTR"></p-sortIcon></th>
      <th pResizableColumn style="width: 8rem !important">Сумма <p-sortIcon field="DOCSUM"></p-sortIcon></th>
      <th pResizableColumn style="width: 8rem !important">Оплачено <p-sortIcon field="PAYDSUM"></p-sortIcon></th>
      <th pResizableColumn style="width: 8rem !important">Отгружено <p-sortIcon field="SHIPSUM"></p-sortIcon></th>
      <th pResizableColumn style="width: 5% !important" class="do-not-overlay-text">Пр. продавца <p-sortIcon field="DOCNOTE1"></p-sortIcon></th>
      <th pResizableColumn style="width: 5% !important" class="do-not-overlay-text">Пр. покупателя <p-sortIcon field="DOCNOTE2"></p-sortIcon></th>
    </tr>
    <tr>
      <th style="width: 4rem"></th>
      <th style="width: 3rem; text-align: center"></th>
      <th style="width: 3rem; text-align: center"></th>
      <th style="overflow: visible !important; ">

        <p-multiSelect #dst [options]="docTypes"
                       placeholder="Все документы"
                       (onChange)="onDocTypeChange($event)"
                       (onSelectAllChange)="onAllDocTypeChange($event)"
                       [(ngModel)]="selectedDocTypes"
                       [showToggleAll]="true"
                       [selectAll]="selectAllTypes"
                       styleClass="p-column-filter p-dropdown-filter-style"
                       optionLabel="DOCNAME1" maxSelectedLabels="1"
                       selectedItemsLabel="{0} документов выбрано"
                       dataKey="DOCTYPEID">
        </p-multiSelect>
      </th>
      <th style="overflow: visible !important; ">
        <input pInputText type="text" (input)="dt.filter($event.target.value, 'DOCNUMBER', 'contains')" placeholder="Поиск"
               [(ngModel)]="documentNumberFilter"
               class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentNumberFilter">
      </th>
      <th style="overflow: visible !important; ">
        <p-calendar [(ngModel)]="filterDate"
                    selectionMode="range"
                    [readonlyInput]="true"
                    showButtonBar="true"
                    selectOtherMonths="true"
                    hideOnDateTimeSelect="true"
                    [firstDayOfWeek]="1"
                    [minDate]="doclistDateRange[0]"
                    [maxDate]="doclistDateRange[1]"
                    showWeek="true"
                    dateFormat="dd/mm"
                    firstDayOfWeek="1"
                    inputId="filter-range"
                    inputStyleClass="p-dropdown-calendar-style"
                    styleClass="p-column-filter"
                    panelStyleClass="p-dropdown-filter-style"
                    (onSelect)="onDateRangeChange( $event)"
                    (onClearClick)="onDateRangeClear( $event)"
                    (onTodayClick)="onTodayClick( $event)">
        </p-calendar>
        <!--<input pInputText type="text" (input)="dt.filter($event.target.value, 'DOCDATE', 'contains')" placeholder="Поиск" class="p-column-filter" style="font-size: 0.8rem; width: 97%" >-->
      </th>
      <th style="overflow: visible !important" *ngIf="showCurrencyColumn">
        <p-multiSelect [options]="curList" placeholder="Все валюты" (onChange)="onCurrListChange($event)" (onSelectAllChange)="onAllCurrListChange($event)" [maxSelectedLabels]="1"
                       [showToggleAll]="true"
                       [selectAll]="selectAllCurr"
                       [(ngModel)]="selectedCurList"
                       styleClass="p-column-filter p-dropdown-filter-style" optionLabel="CURCODE">
        </p-multiSelect>
      </th>
      <th style="overflow: visible !important; ">
        <p-multiSelect [options]="sellerCompany" placeholder="Наши компании" (onChange)="onSellerChange($event)" (onSelectAllChange)="onAllSellerChange($event)"
                       [showToggleAll]="true"
                       [selectAll]="selectAllCompanies"
                       [(ngModel)]="selectedSellerCompany"
                       styleClass="p-column-filter p-dropdown-filter-style" optionLabel="CLIENTSNIKNAME" [maxSelectedLabels]="1"
                       selectedItemsLabel="{0} компаний выбрано" dataKey="CLIID">
        </p-multiSelect>
      </th>
      <th>
        <input pInputText type="text" (input)="dt.filter($event.target.value, 'AUTHOR', 'contains')" placeholder="Поиск"
               [(ngModel)]="documentAuthorFilter"
               class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentAuthorFilter">
      </th>
      <th>
        <input pInputText type="text" (input)="dt.filter($event.target.value, 'PARTNERNAMESTR', 'contains')" placeholder="Поиск"
               [(ngModel)]="documentCompanyFilter"
               class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentCompanyFilter">
      </th>
      <th>
        <input pInputText type="text" (input)="dt.filter($event.target.value, 'DOCSUM', 'gt')" [(ngModel)]="documentDOCSUMFilter"
               placeholder="Больше" class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentDOCSUMFilter"
               pTooltip="Больше указанного числа, или равно 0, если 0" tooltipPosition="top">
      </th>
      <th>
        <input pInputText type="text" (input)="dt.filter($event.target.value, 'PAYDSUM', 'gt')" [(ngModel)]="documentPAYDSUMFilter"
               placeholder="Больше" class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentPAYDSUMFilter"
               pTooltip="Больше указанного числа, или равно 0, если 0" tooltipPosition="top">
      </th>
      <th>
        <input pInputText type="text" (input)="dt.filter($event.target.value, 'SHIPSUM', 'gt')" [(ngModel)]="documentSHIPSUMFilter"
               placeholder="Больше" class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentSHIPSUMFilter"
               pTooltip="Больше указанного числа, или равно 0, если 0" tooltipPosition="top">
      </th>
      <th>
        <input pInputText type="text" (input)="dt.filter($event.target.value, 'DOCNOTE1', 'contains')" placeholder="Поиск"
               [(ngModel)]="documentNote1Filter"
               class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentNote1Filter">
      </th>
      <th>
        <input pInputText type="text" (input)="dt.filter($event.target.value, 'DOCNOTE2', 'contains')" placeholder="Поиск"
               [(ngModel)]="documentNote2Filter"
               class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentNote2Filter">
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-dlCurr let-expanded="expanded">
    <tr [pContextMenuRow]="dlCurr"
        [pSelectableRow]="dlCurr"
        [class.futuredocs]="dlCurr.fd"
        [class.grayout]="dlCurr.go"
        [class.underline]="dlCurr.ps"
        [class.strikeout]="dlCurr.fs"
        [class.partiallypaiddoc]="dlCurr.pp"
        [class.notpaiddoc]="dlCurr.np"
        [class.fullypaiddoc]="dlCurr.fp"
        [class.todaydocuments]="dlCurr.td"
        [class.proformadoc]="(dlCurr.DOCTYPEID == 12)"
        [class.inorderdoc]="(dlCurr.DOCTYPEID == 2)"
        [class.banktransferdoc]="(dlCurr.DOCTYPEID == 9)"
        [class.purchorderdoc]="(dlCurr.DOCTYPEID == 10)"
        [class.yellowdoc]="(dlCurr.DOCTYPEID == 14)"
        [class.specdoc]="(dlCurr.DOCTYPEID == 7)"
        [class.shiporderdoc]="(dlCurr.DOCTYPEID == 4)"
        [class.invoicedoc]="(dlCurr.DOCTYPEID == 1)">
      <td style="text-align: center">
        <p-tableRadioButton [value]="dlCurr"></p-tableRadioButton>
      </td>
      <td style="text-align: center">
        <button type="button" pButton pRipple [pRowToggler]="dlCurr" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
      </td>
      <td style="text-align: center">
        <!--        // Here is the place to put the status of the document-->
        <i class="pi pi-check-circle" style="color: green" *ngIf="dlCurr.DOCFLAG==0"></i>
        <span *ngIf="dlCurr.DOCFLAG!=0">
          <a [routerLink]="['/edit-document', dlCurr.DOCTYPEID, dlCurr.DOCID, 'err']"><i class="pi pi-question-circle" style="color: red"></i></a>
        </span>
      </td>
      <td>{{dlCurr.DOCNAME}}</td>
      <td>
        <a [routerLink]="['/edit-document', dlCurr.DOCTYPEID, dlCurr.DOCID]">{{dlCurr.DOCNUMBER}}</a>
      </td>
      <td class="CellWithComment" style="">
        <span class="CellComment">{{dlCurr.DOCVALDATE | date:'dd.MM.yyyy'}}<br />{{dlCurr.DOCEXPDATE | date:'dd.MM.yyyy'}}</span>{{dlCurr.DOCDATE | date:'dd.MM.yyyy' }}
      </td>
      <td *ngIf="showCurrencyColumn">{{dlCurr.CURSTR}}</td>
      <td>{{dlCurr.LOCALCOMP}}</td>
      <td>{{dlCurr.AUTHOR}}</td>

      <td>
        <a *ngIf="!showFullNameColumn" [routerLink]="['/edit-client', dlCurr.DOCCLIENTSID]">{{dlCurr.PARTNERNAME}}</a>
        <a *ngIf="showFullNameColumn"  [routerLink]="['/edit-client', dlCurr.DOCCLIENTSID]">{{dlCurr.PARTNERNAMESTR}}</a>
        <span class="CellWithComment ml-2"><i class="pi pi-question-circle"></i><span class="CellComment">{{dlCurr.CLIENTSNAME}}</span></span>
      </td>

      <td style="text-align: right">{{dlCurr.DOCSUM | number:'1.2-2'}}</td>
      <td style="text-align: right">{{dlCurr.PAYDSUM | number:'1.2-2' }}</td>
      <td style="text-align: right">{{dlCurr.SHIPSUM | number:'1.2-2' }}</td>
      <td><input pInputText type="text" [(ngModel)]="dlCurr.DOCNOTE1" [style]="{'padding':'0.25rem'}" readonly alt="{{dlCurr.DOCNOTE1}}"></td>
      <td><input pInputText type="text" [(ngModel)]="dlCurr.DOCNOTE2" [style]="{'padding':'0.25rem'}" readonly alt="{{dlCurr.DOCNOTE2}}"></td>

      <!--<td style="">{{dlCurr.DOCNOTE1}}</td>
      <td style="">{{dlCurr.DOCNOTE2}}</td>-->
    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-dlCurr>
    <tr>
      <td colspan="15" *ngIf="showCurrencyColumn">
        <app-document-content-table [selectedDocumentId]="dlCurr.DOCID"></app-document-content-table>
      </td>
      <td colspan="14" *ngIf="!showCurrencyColumn">
        <app-document-content-table [selectedDocumentId]="dlCurr.DOCID"></app-document-content-table>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="14" *ngIf="showCurrencyColumn">Документов не найдено</td>
      <td colspan="14" *ngIf="!showCurrencyColumn">Документов не найдено</td>
    </tr>
  </ng-template>
</p-table>
<p-scrollTop />
